// BASE
export const BASE_URL = import.meta.env.VITE_FRONT_DOMAIN

////////////////////////////// ADMIN //////////////////////////////////

// HOME
export const ADMIN_HOME = import.meta.env.VITE_ADMIN_PATH || '/admin';

// AUTH
export const ADMIN_LOGIN = `${ADMIN_HOME}/login`;

// PRODUCTS
export const ADMIN_PRODUCTS = `${ADMIN_HOME}/products`;

// OFFERS
export const ADMIN_MOBILE_OFFERS = `${ADMIN_HOME}/offers/mobile`;
export const ADMIN_NAUTA_OFFERS = `${ADMIN_HOME}/offers/nauta`;

// USERS
export const ADMIN_USERS = `${ADMIN_HOME}/users`;

// GROUPS
export const ADMIN_GROUPS = `${ADMIN_HOME}/groups`;

// LINK
export const ADMIN_LINK = `${ADMIN_HOME}/link`;

// KPI
export const ADMIN_KPI = `${ADMIN_HOME}/kpi`;

// INVITE
export const ADMIN_INVITE = `${ADMIN_HOME}/invite`;

// SETTING
export const ADMIN_SETTING = `${ADMIN_HOME}/setting`;

// PERSONALIZE
export const ADMIN_PERSONALIZE = `${ADMIN_HOME}/personalize`;

export const ADMIN_ADMINISTRATION = `${ADMIN_HOME}/administration`;

// SYSTEM
export const ADMIN_SYSTEM_JOBS = `${ADMIN_HOME}/system/jobs`;

export const ADMIN_ROUTES = [
  ADMIN_HOME,
  ADMIN_LOGIN,
  ADMIN_PRODUCTS,
  ADMIN_MOBILE_OFFERS,
  ADMIN_NAUTA_OFFERS,
  ADMIN_USERS,
  ADMIN_GROUPS,
  ADMIN_LINK,
  ADMIN_KPI,
  ADMIN_INVITE,
  ADMIN_SETTING,
  ADMIN_ADMINISTRATION,
  ADMIN_SYSTEM_JOBS,
];

////////////////////////////// CLIENT //////////////////////////////////

// HOME
export const HOME = '/';

// AUTH
export const LOGIN = '/login';
export const REGISTER = '/register';
export const REGISTER_INVITATION = '/register/:token';
export const EMAIL_CONFIRMATION = '/email-confirmation';
// export const LOGOUT = '/logout';
export const PASSWORD_RECOVERY = '/password-recovery';
export const PASSWORD_CHANGE = '/password-change/';

// CONTACTS
export const CONTACTS = '/contacts';

// RECHARGES
export const RECHARGES = '/recharges';

// INVITE
export const INVITE = '/invite';
export const INVITE_TOKEN = `${INVITE}/:token`;

// SETTING
export const SETTING = '/setting';

// HELP
export const HELP = '/help';

// LINK
export const LINK = '/link';
export const LINK_TOKEN = `${LINK}/:token`;

// PORFILE
export const PROFILE = '/profile';

// REDSYS
export const THREE_DS_METHOD = '/3ds-method';
export const THREE_DS_METHOD_LINK = '/3ds-method-link';

// PAYMENT
export const PAYMENT_SUCCESS = '/success';
export const PAYMENT_ERROR = '/error';

// MOBILE CHECKOUT
export const MOBILE_CHECKOUT = '/mobile-checkout';
export const MOBILE_CHECKOUT_SUCCESS = '/mobile-checkout-success';
export const MOBILE_CHECKOUT_CANCEL = '/mobile-checkout-cancel';

// OFFERTS
export const OFFERS = '/offerts';

// AGENDA
export const AGENDA = '/agenda';

// ABOUT US
export const ABOUT_US = '/about-us';

// OTHERS
export const TERMS_AND_CONDITIONS = '/terms-and-conditions';
export const POLITICS = '/politics';
export const LEGAL_NOTICE = '/legal-notice';
export const COOKIE_POLICY = '/cookie-policy';
export const USER_DATA = '/user-data';
export const DELETE_ACCOUNT = '/delete-account';

export const CLIENT_ROUTES = [
  HOME,
  LOGIN,
  REGISTER,
  REGISTER_INVITATION,
  EMAIL_CONFIRMATION,
  PASSWORD_RECOVERY,
  PASSWORD_CHANGE,
  CONTACTS,
  RECHARGES,
  INVITE,
  INVITE_TOKEN,
  SETTING,
  HELP,
  LINK,
  LINK_TOKEN,
  PROFILE,
  THREE_DS_METHOD,
  THREE_DS_METHOD_LINK,
  PAYMENT_SUCCESS,
  PAYMENT_ERROR,
  MOBILE_CHECKOUT,
  MOBILE_CHECKOUT_SUCCESS,
  MOBILE_CHECKOUT_CANCEL,
  OFFERS,
  AGENDA,
  ABOUT_US,
  TERMS_AND_CONDITIONS,
  POLITICS,
  DELETE_ACCOUNT,
];